// extracted by mini-css-extract-plugin
module.exports = {"article-meta-container":"ArticleInfoSection_article-meta-container__ke9yx","info-card-container":"ArticleInfoSection_info-card-container__rsegW"};